<template>
  <RemarkCard
    v-if="item.kind === 'remark-card'"
    :remark="item"
    show-context-btn
    show-context
    show-tags
    part-of="inbox"
  />
  <NotificationContent v-else type="CheckList" :communication-item="item" />
</template>

<script setup lang="ts">
import RemarkCard from '@app/shared/vue/components/molecules/remark/remark-card.vue'
import NotificationContent from '@app/application/communication/screens/inbox/components/notification-content.vue'
import type { CheckLink, Remark } from '@app/application/communication/types'

interface Props {
  item: Remark | CheckLink
}
defineProps<Props>()
</script>
